module.exports = __webpack_public_path__ + "media/src/images/icons/gray-chevron-forward-b15e76b5e675a0567fbbe85d20dd5001.svg";